import React from 'react';
import styled, { css } from 'styled-components';

import { Row } from '../../global/grid/grid';

import colors from '../../../vars/colors';
import breakpoints from '../../../vars/breakpoints';
import gutters from '../../../vars/gutters';

export const Tile = styled.div`
    width: 100%;
`;

export const ContentWrapper = styled.div`
    width: 100%;
    padding-top: 100%;
    position: relative;
    border: solid 5px ${colors['peacock-blue']};
    box-sizing: border-box;
    background: white;
`;

export const Content = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .label {
        font-family: 'OneDotExt', sans-serif;
        font-weight: bold;
        font-size: 15px;
        color: ${colors['peacock-blue']};
        text-transform: uppercase;
    }
    .dataPoint {
        font-family: 'OneDotCd', sans-serif;
        font-weight: bold;
        font-size: 130px;
        color: ${colors['lipstick']};
    }
`;

export const ImageRow = styled(Row)`
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    z-index: -1;
`;

export const ColorBlock = styled.div`
    position: absolute;
    width: 50%;
    bottom: 50%;
    background: repeating-linear-gradient(-45deg, ${colors['peacock-blue']}, ${colors['peacock-blue']} 25px, rgba(255, 255, 255, 0.5) 25px, rgba(255, 255, 255, 0.5) 50px);
    top: calc(${gutters['container-gutters-desktop-l']} * -0.7);
    left: calc(${gutters['container-gutters-desktop-l']} * -0.8);
    @media (max-width: ${breakpoints['bp-desktop']}) {
        top: calc(${gutters['container-gutters-desktop']} * -0.7);
        left: calc(${gutters['container-gutters-desktop']} * -0.8);
    }
    @media (max-width: ${breakpoints['bp-tablet']}) {
        top: calc(${gutters['container-gutters-tablet']} * -0.7);
        left: calc(${gutters['container-gutters-tablet']} * -0.8);
    }
    @media (max-width: ${breakpoints['bp-mobile']}) {
        top: calc(${gutters['container-gutters-mobile']} * -0.7);
        left: calc(${gutters['container-gutters-mobile']} * -0.8);
    } 
`;

export const CardHolder = styled.div`
    z-index: 3;
    position: absolute;
    width: 95%;
    top: 25%;
    right: calc(${gutters['container-gutters-desktop-l']} * -0.3);
    @media (max-width: ${breakpoints['bp-desktop']}) {
        right: calc(${gutters['container-gutters-desktop']} * -0.3);
    }
    @media (max-width: ${breakpoints['bp-tablet']}) {
        right: calc(${gutters['container-gutters-tablet']} * -0.3);
    }
    @media (max-width: ${breakpoints['bp-mobile']}) {
        right: calc(${gutters['container-gutters-mobile']} * -0.3);
    } 
`;


// WEBPACK FOOTER //
// ./src/components/modules/CampaignSummary/styled-components.js